<template>
  <div class="notifications card text-md" id="tpl_kssChamp_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon
          icon="fa-xmark"
        />
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex break-words items-start">
        <font-awesome-icon
          class="w-12 h-12"
          v-if="notification.content && notification.content.icon"
          :icon="notification.content.icon"
        ></font-awesome-icon>
        <h3 v-if="notification.content && notification.content.header && notification.content.header[lang]" class="pl-3">
          <span id="txt_kssChampionNotificationHeader">
            {{ notification.content.header[lang] }}
          </span>
        </h3>
      </div>
      <div v-if="notification.content && notification.content.text && notification.content.text[lang]"
       class="flex break-normal">
        <h4 id="tpl_kss_champion_popup_h3" class="break-normal">
          {{ notification.content.text[lang] }}
        </h4>
      </div>
    </div>
    <div class="flex justify-end">
      <!-- In-app route (e.g. travelBuddyAssigned): same window, like assessments -->
      <button
        v-if="inAppRoute && buttonLabel"
        type="button"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full
         text-lg bg-[var(--color-orange)] text-center text-inherit border-0 cursor-pointer"
        name="regist"
        id="btn_regist"
        @click="navigateInApp"
      >{{ buttonLabel }}</button>
      <a
        v-else-if="notification.content && notification.content.tenantUrl && buttonLabel"
        :href="notification.content.tenantUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full
         text-lg bg-[var(--color-orange)] text-center text-inherit no-underline"
        name="regist"
        id="btn_regist"
      >{{ buttonLabel }}</a>
      <button
        v-else-if="buttonLabel"
        type="button"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full text-lg bg-[var(--color-orange)] border-0"
        name="regist"
        id="btn_regist"
        @click="deactivate"
      >{{ buttonLabel }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTaskNotificationComponent',
  props: ['notification'],
  computed: {
    lang() {
      return this.$i18n?.locale || 'en';
    },
    buttonLabel() {
      const btn = this.notification?.content?.positiveButton;
      if (btn && typeof btn === 'object') {
        return btn[this.lang] || btn.en || btn.de || '';
      }
      return '';
    },
    inAppRoute() {
      const content = this.notification?.content || {};
      const route = content.route || content.path;
      if (typeof route === 'string' && route.startsWith('/')) {
        return route;
      }
      if (this.notification?.event === 'travelBuddyAssigned') {
        return '/travel-buddy-history';
      }
      return null;
    },
  },
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
    async navigateInApp() {
      if (!this.inAppRoute) {
        this.deactivate();
        return;
      }
      try {
        await this.$router.push(this.inAppRoute);
      } catch (err) {
        // ignore NavigationDuplicated
      }
      this.deactivate();
    },
  },
};
</script>
